<h1 mat-dialog-title>Masowa aktualizacja transakcji ({{ data.selected.length }})</h1>
<div mat-dialog-content>
	<p>Tylko zmienione pola będą zapisane.</p>
	<mat-form-field class="full">
		<mat-select placeholder="Kraj" name="country" [(ngModel)]="fields.country">
			<mat-option value="">(brak)</mat-option>
			@for (ctr of data.countries; track ctr.id) {
				<mat-option [value]="ctr.id">
					{{ ctr.name }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-form-field class="full">
		<mat-select placeholder="Rodzaj" name="type" [(ngModel)]="fields.type">
			<mat-option value="">(brak)</mat-option>
			@for (opt of data.types; track opt.id) {
				<mat-option [value]="opt.id">
					{{ opt.name }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-checkbox [(ngModel)]="fields.originalDocument" color="primary">Oryginał dokumentu</mat-checkbox>
	<mat-form-field class="full">
		<mat-label>Osoba odpowiedzialna</mat-label>
		<mat-select name="currentOwnerTransactions" [(ngModel)]="fields.currentOwnerTransactions">
			<mat-option value="">(brak)</mat-option>
			@for (item of data.currentOwnerTransactions; track item.currentOwnerName) {
				<mat-option [value]="item.currentOwnerName">
					{{ item.currentOwnerName }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-form-field class="full">
		<mat-label>Uwagi</mat-label>
		<textarea matInput [(ngModel)]="fields.comment"></textarea>
	</mat-form-field>

	<mat-form-field class="full">
		<mat-label>Faktura</mat-label>
		<input matInput [(ngModel)]="fields.fvNumber" />
	</mat-form-field>

	<mat-form-field class="full">
		<mat-label>Wydarzenie</mat-label>
		<input
			matInput
			[formControl]="tourismEventControl"
			[matAutocomplete]="autoEvent"
			placeholder="Wpisz nazwę wydarzenia (min. 3 znaki)"
		/>
		<mat-autocomplete
			#autoEvent="matAutocomplete"
			[displayWith]="displayTourismEventFn.bind(this)"
			(optionSelected)="onTourismEventSelected($event)"
		>
			@for (event of filteredTourismEvents; track event.id) {
				<mat-option [value]="event">
					{{ event.name }}
				</mat-option>
			}
		</mat-autocomplete>
	</mat-form-field>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onCancel()" color="warn">Anuluj</button>
	<button mat-button (click)="onSave()" color="primary" cdkFocusInitial [disabled]="isFormValid()">
		Zapisz zmiany
	</button>
</div>
